import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContentPage } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class ContentPagesService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  getPages() {
    return this.http.get<ContentPage[]>(`${this.BASE_URL}api/pages`);
  }

  getPageBySlug(slug: string) {
    return this.http.get<ContentPage>(`${this.BASE_URL}api/pages/${slug}`);
  }

  getPageById(id: number) {
    return this.http.get<ContentPage>(`${this.BASE_URL}api/pages/${id}`);
  }
}
